<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'编辑分类':'新增分类'" :visible.sync="dialog" @close="unShowClick()" width="40%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-tabs v-model="activeName" v-if="isEdit">
					<el-tab-pane label="中文" name="zh"></el-tab-pane>
					<el-tab-pane label="英文" name="en"></el-tab-pane>
					<el-tab-pane label="日语" name="jp"></el-tab-pane>
				</el-tabs>
				<el-form-item label="所属类目" :label-width="formLabelWidth">
					<el-select v-model="addBody.parent_id" placeholder="请选择所属类目">
						<el-option v-for="item in lmList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="分类名称" prop="title" :label-width="formLabelWidth" v-if="activeName == 'zh'">
					<el-input v-model="addBody.title" placeholder="请输入分类名称"></el-input>
				</el-form-item>
				<el-form-item label="分类名称" prop="title_e" :label-width="formLabelWidth" v-if="activeName == 'en'">
					<el-input v-model="addBody.title_e" placeholder="请输入分类名称"></el-input>
				</el-form-item>
				<el-form-item label="分类名称" prop="title_j" :label-width="formLabelWidth" v-if="activeName == 'jp'">
					<el-input v-model="addBody.title_j" placeholder="请输入分类名称"></el-input>
				</el-form-item>
				<el-form-item label="权重" prop="sort" :label-width="formLabelWidth">
					<el-input v-model="addBody.sort" placeholder="请输入权重"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addArticleCategory,
		editArticleCategory,
		ArticleCategory
	} from '@/api/school-manage'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					parent_id: '',
					title: '',
					title_e: "",
					title_j: "",
					sort: '',
					uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					parent_id: [{
						required: true,
						message: '请选择所属类目',
						trigger: 'blur'
					}, ],
					title: [{
						required: true,
						message: '请输入分类名称',
						trigger: 'blur'
					}, ],
					title_e: [{
						required: true,
						message: '请输入分类名称',
						trigger: 'blur'
					}, ],
					title_j: [{
						required: true,
						message: '请输入分类名称',
						trigger: 'blur'
					}, ],
					sort: [{
						required: true,
						message: '请输入权重',
						trigger: 'blur'
					}, ]
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [{
						id: '007889c8b35bedb57876ac91f9dffc1e',
						name: '研发灵感'
					},
					{
						id: '11aa6cec60c96d23c50b8c9ff57d9427',
						name: '产品灵感'
					},
					{
						id: '54e29715-d06f-0e6168c7dfa79b594d',
						name: '营销灵感'
					},
					{
						id: '9f865cdc4ee64131a2abdb8e6762cdb4',
						name: '全部'
					}
				]
			}
		},
		mounted() {},
		methods: {
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().editArticleCategory()
						} else {
							this.network().addArticleCategory()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.isEdit = false
				this.$emit('input', false)
			},
			network() {
				return {
					addArticleCategory: async () => {
						const {
							status,
							data
						} = await addArticleCategory({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					editArticleCategory: async () => {
						const {
							status
						} = await editArticleCategory({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					ArticleCategory: async (uuid) => {
						const {
							data,
							status
						} = await ArticleCategory({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.network().ArticleCategory(val.uuid)
				} else {
					this.addBody.parent_id = ''
					this.addBody.title = ''
					this.addBody.title_e = ''
					this.addBody.title_j = ''
					this.addBody.sort = ''
					this.addBody.uuid = ''
				}
				this.addBody.role_uuid = val.role_uuid
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>